import LegacyPage from '~/components/LegacyPage';

export default LegacyPage;
